module.exports = __webpack_public_path__ + "static/media/akash-kumar-singh.e4c6e6d7.png";